import { setupI18n, type I18n, type Messages } from "@lingui/core";
import { locale } from "src/config/app-config";

export const I18N_CATALOG_SCRIPT_ID = "__I18N_CATALOG__";

export type I18nStoreState = {
  catalog: Messages;
  i18n: I18n;
};

function createState(catalog: Messages): I18nStoreState {
  return {
    catalog,
    i18n: setupI18n({ locale, messages: { [locale]: catalog } }),
  };
}

function readCatalogFromDocument(): Messages {
  const content = document.getElementById(I18N_CATALOG_SCRIPT_ID)?.textContent;
  return content ? (JSON.parse(content) as Messages) : {};
}

export function serializeCatalog(catalog: Messages): string {
  return JSON.stringify(catalog).replace(/</g, "\\u003c");
}

const EMPTY_STATE = createState({});

let state: I18nStoreState | undefined;

const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

function getState(): I18nStoreState {
  if (!state && typeof document !== "undefined") {
    state = createState(readCatalogFromDocument());
  }
  return state || EMPTY_STATE;
}

export const i18nStore = {
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getSnapshot: getState,
  getServerSnapshot: getState,

  setCatalog: (catalog: Messages) => {
    if (state?.catalog === catalog) {
      return;
    }
    state = createState(catalog);
    emit();
  },

  reset: () => {
    state = undefined;
    emit();
  },
};
